module.exports = __webpack_public_path__ + "static/media/Deer_stone_icon.61679cad.png";